module.exports = __webpack_public_path__ + "img/fhqr1.3a92f284.png";